import UserProfile from './UserProfile';
import UserProfileEdit from './UserProfileEdit';
import UserProfileVerifier from './UserProfileVerifier';

export default UserProfile;
export { UserProfileEdit, UserProfileVerifier };
